import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { translate } from "@jsverse/transloco";
import collect from 'collect.js';
import { untilDestroyed } from "ngx-take-until-destroy";
import { BehaviorSubject, Observable } from "rxjs";
import { finalize, map } from "rxjs/operators";
import { ProjectsService } from 'src/app/akita/project/state/projects.service';
import { ConfigsService } from 'src/app/core/service/api/configs.service';
import { arcgisTypeDefine, integrationError, integrationValidationArcGis } from "src/app/core/util/integration";
import { Activity } from "../../../../akita/activities/state/activity.model";
import { Complaint } from "../../../../akita/complaints/state/complaint.model";
import { Middel } from "../../../../akita/content/state/middel.model";
import { Issue } from "../../../../akita/issues/state/issue.model";
import { Decision } from "../../../../akita/requirements/state/decision.model";
import { Resident } from "../../../../akita/residents/state/resident.model";
import { Stakeholder } from "../../../../akita/stakeholders/state/stakeholder.model";
import {
  Subproject,
  createSubproject,
} from "../../../../akita/subproject/state/subproject.model";
import { SubprojectQuery } from "../../../../akita/subproject/state/subprojects.query";
import { SubprojectsService } from "../../../../akita/subproject/state/subprojects.service";
import { Action } from "../../../../akita/tasks/state/action.model";
import { CachedService } from "../../../../core/service/common/cached.service";
import { WithParams } from "../../../../core/service/common/with-params";
import { scrollToError } from "../../../../core/util/form";
import {
  showFeedbackRemoved,
  showFeedbackSaved,
} from "../../../../core/util/notification";
import { Globals } from "../../../../globals";
import { DeletionModalComponent } from "../../../../shared/components/modal/deletion-modal/deletion-modal.component";
import { OpenlayersMapComponent } from "../../openlayers-map/openlayers-map.component";
import { GenericComponent } from "src/app/core/util/abstract/generic-component";
import { MatSnackBar } from "@angular/material/snack-bar";


@Component({
  selector: "app-subproject-edit",
  templateUrl: "./subproject-edit.component.html",
  styleUrls: ["./subproject-edit.component.sass"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubprojectEditComponent extends GenericComponent implements OnInit, OnDestroy {
  public stakeholders: Stakeholder[];
  public residents: Resident[];
  public issues: Issue[];
  public decisions: Decision[];
  public complaints: Complaint[];
  public activities: Activity[];
  public middel: Middel[];
  public actions: Action[];
  public formGroup: FormGroup;
  public roles:any=[];
  public isLoader=false;
  public users:any=[];
  public selectedSubprojectRoles:any=[];
  public selectedUsers:any=[];
  public mainProjectRoles:any=[];
  public subProjectCopy: Subproject = createSubproject("Copy", null);
  public subprojectRoles:any=[];
  public subprojectUsers:any=[];
  public layerFeatures: any = [];
  public selectedFeatues: any = [];
  public selectedFeatures:any[] = [];
  public previousLayer:any = null;
  public selectType:string = 'add';
  public integrationEnable: boolean=false;
  public activeArcGis:string='arcgis';
  public errorIntegration: boolean=false;
  public errorIntegrationEnterprise: boolean=false;
  public nameExists: boolean = false;
  public integrationCheck: string;
  public parent_id: any = null;
  public allsubprojects: any = [];
  public subprojectName: string = ""
  public subprojectMapFeatures = {
    arcgis: [],
    opendata: []
  };
  public featureSelectedType!: string;
  public isDeleteDisabled: boolean = false;
  @ViewChild(OpenlayersMapComponent, {static: false}) map: OpenlayersMapComponent;
  @ViewChild("form", { static: false }) form: NgForm;

  private processingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private subProjectRelations: string[] = [
    "locations","layers","stakeholders","tasks","requirements","complaints","activities","contents"
  ];
  public processing$: Observable<boolean> = this.processingSubject.asObservable();
  constructor(
    @Inject(MAT_DIALOG_DATA) public subProject: Subproject,
    public globals: Globals,
    public dialogRef: MatDialogRef<any>,
    private subProjectQuery: SubprojectQuery,
    private formBuilder: FormBuilder,
    private _cachedService: CachedService,
    private _subprojectsService: SubprojectsService,
    private confgs: ConfigsService,
    public subpro: MatDialog,
    private cd: ChangeDetectorRef,
    private projectsService: ProjectsService,
    public snackbar: MatSnackBar
  ) {
    super();
  }

  ngOnInit() {
    this.allsubprojects = this.subProjectQuery.getAll();
    this.parent_id = this.subProject.parent_id;
    this.subprojectName = this.subProject.name;
    this.isDeleteDisabled = this.subProject.children.length > 0 ? true : false;
    this.activeArcGis=arcgisTypeDefine(this.globals);
    this.errorIntegration=integrationError(this.globals,'arcgis_enabled');
    this.errorIntegrationEnterprise=integrationError(this.globals,'arcgis_enterprise_enabled');
    this.integrationCheck=integrationValidationArcGis(this.globals,'arcgis','arcgis_enterprise','arcgis_enabled','arcgis_enterprise_enabled',this.errorIntegration,this.errorIntegrationEnterprise);
    if(this.integrationCheck==='project'){
      this.integrationEnable=true;
    }
    this.mainroleFinder();
    this.getRoles();
    this._subprojectsService
      .select(
        this.subProject.id,
        new WithParams().with(this.subProjectRelations)
      )
      .pipe(untilDestroyed(this))
      .subscribe((res: any) => {
        this.subProject = this.subProjectQuery.getEntity(this.subProject.id);
        this.selectedUsers = this.subProject.users.filter(user => user.roles && user.roles.length > 0);        
        this.initForm();
        this.getSubprojectUsers()
      });

    this.initForm();

    this.formGroup.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((change: Subproject) => {
        this.subProject = change;
      });

    this._cachedService.ignoreSubProject = true;

    this._cachedService.getStakeholders().subscribe(
      stakeholders => {this.stakeholders = stakeholders
      this.cd.detectChanges();
    });
    this._cachedService.getResidents().subscribe(
      residents => this.residents = residents
    );
    this._cachedService.getIssues().subscribe(
      issues => this.issues = issues
    );
    this._cachedService.getDecisions().subscribe(
      decisions => this.decisions = decisions
    );
    this._cachedService.getComplaints().subscribe(
      complaints => this.complaints = complaints
    );
    this._cachedService.getActivities().subscribe(
      activities => this.activities = activities
    );
    this._cachedService.getMiddel().subscribe(
      middel => this.middel = middel.map(m => {
        if (m.activities) {
          m.name = `${m.type} voor activiteit ${m.activities.name}`;
        } else {
          m.name = m.type;
        }

        return m;
      })
    );
    this._cachedService.getActions().subscribe(
      actions => this.actions = actions,
    );
  }

  private initForm(): void {
    this.subProject.all = this.subProject.all === undefined ? false: this.subProject.all;
    this.formGroup = this.formBuilder.group({
      id: [this.subProject.id, Validators.required],
      name: [this.subProject.name, Validators.required],
      locations: [this.subProject.locations, Validators.required],
      layers: [this.subProject.layers],
      users:[],
      stakeholders: [
        {
          value: this.subProject.all ? null : this.subProject.stakeholders,
          disabled: this.subProject.all,
        },
      ],
      residents: [
        {
          value: this.subProject.all ? null : this.subProject.residents,
          disabled: this.subProject.all,
        },
      ],
      issues: [
        {
          value: this.subProject.all ? null : this.subProject.issues,
          disabled: this.subProject.all,
        },
      ],
      requirements: [
        {
          value: this.subProject.all ? null : this.subProject.requirements,
          disabled: this.subProject.all,
        },
      ],
      complaints: [
        {
          value: this.subProject.all ? null : this.subProject.complaints,
          disabled: this.subProject.all,
        },
      ],
      activities: [
        {
          value: this.subProject.all ? null : this.subProject.activities,
          disabled: this.subProject.all,
        },
      ],
      contents: [
        {
          value: this.subProject.all ? null : this.subProject.contents,
          disabled: this.subProject.all,
        },
      ],
      tasks: [
        {
          value: this.subProject.all ? null : this.subProject.tasks,
          disabled: this.subProject.all,
        },
      ],
      all: [this.subProject.all || false, Validators.required],
    });
    this.formGroup.value.layers.forEach(feature => {
      switch(feature.type){
        case 'arcGis':
          this.subprojectMapFeatures.arcgis.push(feature);
          break;
        case 'openData':
          this.subprojectMapFeatures.opendata.push(feature);
          break;
      }
    })
    this.cd.detectChanges();
  }

  public close(): void {
    this.dialogRef.close();
    this.snackbar.dismiss();
  }

  public subprojectExists(): void {
    this.nameExists = false;
    const name = this.formGroup.value.name?.trim().toLowerCase();
    this.nameExists = this.allsubprojects.some(
      (sp) => sp.name?.trim().toLowerCase() === name
    );
    if (this.subProject && this.subprojectName === name) {
      this.nameExists = false;
    }
  }

  public update(): void {
    this.formGroup.patchValue({
        stakeholders: this.subProject.stakeholders,
        tasks: this.subProject.tasks,
        issues: this.subProject.issues,
        requirements: this.subProject.requirements,
        complaints: this.subProject.complaints,
        activities: this.subProject.activities,
        contents: this.subProject.contents
    });
    if (this.form.invalid || this.nameExists) {
      scrollToError();
      return;
    }
    if (this.subProject.layers.length) {
      const layers = this.subProject.layers;
      let layersCount = 0;
      this.selectedFeatues = [];
      layers.forEach((layer: any) => {
        const singleLayer = {
            type: layer.type,
            id_field: layer.id_field,
            layer_id: layer.layer_id,
            layer_name: layer.layer_name,
            title: layer.title,
            main_layer_id: layer.main_layer_id,
            sub_layer_id: layer.sub_layer_id,
            sub_layer_name: layer.sub_layer_name
          }
        this.confgs.setLayerConection({layers: singleLayer}).subscribe( (res: any) => {
          layersCount++;
          const idLayer = {
            id: res.id,
            id_field: res.id_field,
            layer_id: res.layer_id,
            layer_name: res.layer_name,
            title: res.title,
            type: layer.type,
            main_layer_id: res.main_layer_id,
            sub_layer_id: res.sub_layer_id,
            sub_layer_name: res.sub_layer_name
          }
          this.selectedFeatues.push(idLayer);
          if(layersCount === layers.length) {
            this.updateSubproject()
          }
        })
      })
    }else{
      this.updateSubproject()
    }
  }
  updateSubproject() {
    this.formGroup.patchValue({layers: this.selectedFeatues.length ? this.selectedFeatues : []});
    this.formGroup.value.users=this.subProject.users;
    this.formGroup.value.parent_id=this.parent_id;
    this.processingSubject.next(true);
    this._subprojectsService
      .update(this.formGroup.value)
      .pipe(finalize(() => this.processingSubject.next(false)))
      .subscribe((subProject) => {
        if (!subProject) {
          return;
        }
        this.loderIntoGlobal();
        showFeedbackSaved();
        this.dialogRef.close(subProject);
        this.snackbar.dismiss();
      });
  }

  public ngOnDestroy(): void {
    this._cachedService.ignoreSubProject = false;
  }
  public deleteSubproject(subProject) {
    const label = this.globals.projectConfigs['project.labels.subprojects']
    const data = label? `Weet u zeker dat u het ${ label } wilt verwijderen?` : `Weet u zeker dat u het ${ translate('subprojects.label_small') } wilt verwijderen?`
    const dialogRef = this.subpro.open(DeletionModalComponent, {
      data: data,
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe((remove: boolean) => {
      if (remove) {
        this.processingSubject.next(true);
        this._subprojectsService
          .deletesubproject(subProject)
          .pipe(finalize(() => this.processingSubject.next(false)))
          .subscribe(() => {
            this.loderIntoGlobal();
            showFeedbackRemoved();
            this.dialogRef.close(subProject);
            this.snackbar.dismiss();
          });
      }
    });
  }
  public subprojectRolesSelect(){
    if(this.subProject.users.length>0){
      this.subProject.users.forEach((element:any,key) => {
          element.roles=this.selectedSubprojectRoles[key];
      });
    }
  }
  public getSubprojectUsers(){
    this._subprojectsService.getSubprojectUsers().subscribe((res:any)=>{
      this.users=res.data;
      this.isLoader=true;
      this.rolesSeparator();
      this.cd.detectChanges();
    })
  }
  public getRoles(){
    this.projectsService.getUserRoles().subscribe(res=>{
      this.roles=res;
      this.roles.forEach(element => {
        if(element.name!=='Project Admin'){
          this.subprojectRoles.push(element);
        }
      });
    })
  }
  public rolesSeparator(){
    this.userLogic();
    this.subprojectUsers.forEach((element:any,key) => {
      if(element.roles){
        this.selectedSubprojectRoles[key]=element.roles;
      }
      else{
        this.selectedSubprojectRoles[key]=[];
      }
    });
    this.rolesDeclare();
    this.cd.detectChanges();
  }
  public mainroleFinder(){
    if(this.globals.user.scope){
      this.globals.user.scope.data.forEach(element => {
        if(!element.is_subproject){
          this.mainProjectRoles=element.roles;
        }
      });
    }
  }
  public rolesDeclare(){
    const rolesFromPrents=[];
    this.mainProjectRoles.forEach(element => {
      if(element.name!=='Project Admin'){
        rolesFromPrents.push(element);
      }
    });
    this.subprojectUsers.forEach((element,index)=> {
      // Keep a role already set on the subproject - it overrides the project
      // role - and only prefill when there is none.
      if(!this.selectedSubprojectRoles[index] || !this.selectedSubprojectRoles[index].length){
        this.selectedSubprojectRoles[index]=rolesFromPrents;
      }
    });
  }
  public userLogic(){
    const temp=[];
    const subProject_id=[];
    this.subProject.users.forEach((element:any) => {
      subProject_id.push(element.id);
    });
    this.users.forEach(element => {
        if(!subProject_id.includes(element.id)){
          temp.push(element);
        }
    });
    this.subprojectUsers=this.subProject.users;
    temp.forEach(element => {
      this.subprojectUsers.push(element);
    });
  }
  public loderIntoGlobal(){
    this._subprojectsService.get(true).subscribe(res=>{
      this.globals.subprojects=res;
    })
  }
  /*
    On Select Integration Feature Add Add to Map
  */
  public onSelectIntegrationFeautes(features: any) {
    this.subprojectMapFeatures.arcgis = features;
    this.featureSelectedType = 'arcgis';
    this.onSetAllFeatureIntoOne();
  }
  /*
    On Select Open Data Feature Add Add to Map
  */
  public onSelectOpenDataFeautes(features: any) {
    this.subprojectMapFeatures.opendata = features;
    this.featureSelectedType = 'opendata';
    this.onSetAllFeatureIntoOne();
  }
  /*
    On Select Feature Add Add to Map
  */
  public onSetAllFeatureIntoOne() {
    this.subProject.layers = [...this.subprojectMapFeatures.arcgis, ...this.subprojectMapFeatures.opendata];
    this.subProject.layers = collect(this.subProject.layers).map((obj, index) => { return { ...obj, id: index };}).all();
    this.subProject.layers = collect(this.subProject.layers).unique('title').all();
    if(this.previousLayer != null){
      if(this.previousLayer.length > this.subProject.layers.length){
        this.selectType = 'remove';
      }else{
        this.selectType = 'add';
      }
    }
    this.selectedFeatures = this.subProject.layers;
    setTimeout(() => {
      this.map.addFeatureDynamically();
    }, 500);
    this.previousLayer = this.subProject.layers;
  }
  onSelectedUser(users: any) {
    this.selectedUsers = users;
  }
  onSelect(item: any){
    this.parent_id = item?.id === undefined ? null : item.id;
  }
  toggleChange(copyAll: boolean): void {
    const copiedList = ['stakeholders', 'activities', 'complaints', 'decisions', 'issues', 'logs', 'middel', 'residents', 'actions',];
    if (copyAll) {
      copiedList.forEach(v => {
        if (this.subProject[v]) {
          this.subProjectCopy[v] = this.subProject[v];
          this.subProject[v] = null;
        }
      });
    } else {
      copiedList.forEach(v => {
        if (this.subProjectCopy[v]) {
          this.subProject[v] = this.subProjectCopy[v];
        }
      });
    }
  }
}
